import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface Props {
  content: string;
  className?: string;
}

const MarkdownContent = ({ content, className = "" }: Props) => {
  return (
    <div
      className={`prose prose-sm md:prose-base max-w-none dark:prose-invert
        prose-headings:font-bold prose-headings:tracking-tight prose-headings:text-foreground
        prose-h1:text-2xl prose-h1:mt-6 prose-h1:mb-3 prose-h1:pb-2 prose-h1:border-b prose-h1:border-border
        prose-h2:text-xl prose-h2:mt-5 prose-h2:mb-2 prose-h2:text-primary
        prose-h3:text-lg prose-h3:mt-4 prose-h3:mb-2
        prose-h4:text-base prose-h4:mt-3 prose-h4:mb-1
        prose-p:text-foreground prose-p:leading-relaxed
        prose-strong:text-foreground prose-strong:font-semibold
        prose-ul:my-2 prose-ol:my-2 prose-li:my-1 prose-li:text-foreground
        prose-table:text-sm prose-th:bg-muted prose-th:text-foreground prose-th:font-semibold
        prose-td:border-border prose-th:border-border
        prose-code:bg-muted prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-foreground prose-code:before:content-none prose-code:after:content-none
        prose-blockquote:border-l-primary prose-blockquote:text-muted-foreground
        prose-hr:border-border
        ${className}`}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownContent;